import { connect } from 'react-redux';
import View from './WhatIfMenuView';
import { fetchGoalWhatIfData, removeWhatIfs } from '../WhatIfsActions';
import {
  loading,
  whatIfsSectionsSelector,
  nullableUrlSelector,
  nullableFpIdSelector,
} from '../WhatIfsSelector';
import {
  goalId as selectedGoalId,
  selectedGoalSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { selectedInsuranceTypeOrDefaultSelector } from '../../FinancialPlan/Insurance/InsuranceSelector';

const mapStateToProps = (state, ownProps) => ({
  loading: loading(state, ownProps),
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  url: nullableUrlSelector(state, ownProps),
  whatIfsSections: whatIfsSectionsSelector(state, ownProps),
  selectedInsuranceType: selectedInsuranceTypeOrDefaultSelector(state, ownProps),
  goalData: selectedGoalSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  fetchData: (clientId, fpId, goalId, url, debtType) => {
    dispatch(fetchGoalWhatIfData(clientId, fpId, goalId, url, debtType));
  },
  removeWhatIf: (clientId, fpId, goalId, url, whatIf, debtType) => event => {
    event.stopPropagation();
    dispatch(removeWhatIfs(clientId, fpId, goalId, url, [whatIf.WhatIf.WhatIfKey], debtType));
  },
});

const WhatIfMenuContainer = connect(mapStateToProps, mapDispatchToProps)(View);

export default WhatIfMenuContainer;
